function trimTrailingSlash(s: string): string {
  return s.replace(/\/$/, '')
}

/**
 * 站点根地址（无末尾 `/`）。
 * 优先 `REACT_APP_PUBLIC_SITE_URL`（例如正式站），其次 `REACT_APP_MAIN_SITE_URL`，否则用当前页 origin。
 */
export function siteOrigin(): string {
  const fromEnv = (
    process.env.REACT_APP_PUBLIC_SITE_URL ||
    process.env.REACT_APP_MAIN_SITE_URL ||
    ''
  ).trim()
  if (fromEnv && /^https?:\/\//i.test(fromEnv)) {
    return trimTrailingSlash(fromEnv)
  }
  if (typeof window !== 'undefined') {
    return trimTrailingSlash(window.location.origin)
  }
  return ''
}

/** 独立博客站路径。同源部署时必须整页跳转，不能走官网 React Router。 */
export function blogUrl(slugOrPath?: string): string {
  const origin = siteOrigin()
  if (!slugOrPath) return `${origin}/blog`
  const trimmed = slugOrPath.replace(/^\/+|\/+$/g, '')
  if (trimmed === 'blog') return `${origin}/blog`
  if (trimmed.startsWith('blog/')) return `${origin}/${trimmed}`
  return `${origin}/blog/${trimmed}`
}
